module.exports = __webpack_public_path__ + "img/planes.633bcb4c.gif";